import { Box, Text, Divider } from "@chakra-ui/react";
import React from "react";
import { FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";

export default function Homepage() {
    return (
        <AppLayout pageTitle={"Hack+Policy Participant Portal"}>
            <Box
                p="3"
                bg="green.100"
                borderRadius="sm"
            >
                <Text fontSize="lg">Registrations for MERGExIndia are still OPEN! Learn more about the event and signup <a style={{fontWeight:"bold"}} target="_blank" href="https://hackpolicy.co/merge/india">here <FiExternalLink style={{display: "inline"}} /></a>.</Text>
            </Box>
            <Box mt="5" fontSize="lg">
                <Text mb="5">Welcome to MERGExIndia! We're delighted to have you participate in this event to solve our society’s most pressing challenges using technology and policy, bridging the gap between STEM and the humanities. We hope that through this event, you will be continuously inspired by your teammates, peers, mentors, and speakers to nurture your interest in merging these two fields into a passion.</Text>
                <Divider />
                <Text mb="5">India has reported more than 19 million cases of the novel coronavirus - second only to the U.S. The death toll is reported to be at a quarter of a million, however, the real number is most definitely higher - not to mention that there's a lack of testing and tracing, as well.</Text>
                <Text mt="5">This, by all means, is a global crisis.</Text>
                <Text mt="5">Our inaugural event, MERGE 2021, was a hack+policython. We decided to expand our community, our goals, and our vision to bring an initiative that will hopefully help ameliorate the current situation in India via MERGExIndia.</Text>
                <Text mt="6"><Link style={{fontWeight: "bold"}} to="/schedule">Schedule <FiExternalLink style={{display: "inline"}} /></Link></Text>
                <Text mt="4"><Link style={{fontWeight: "bold"}} to="/general-information">General Information <FiExternalLink style={{display: "inline"}} /></Link></Text>
            </Box>
        </AppLayout>
    )
}